module.exports = __webpack_public_path__ + "assets/img/29_264.01b7bdc0.jpg";